import React from "react";
import { AdvisorsCard } from "./AdvisorsCard";
import { AdvisorsUIProvider } from "./AdvisorsUIContext";

export function AdvisorsPage({ history }) {
  const advisorsUIEvents = {
    openNewStudentPage: () => {
      history.push("/danisman-ogretmenler/ogrenci-secme");
    }
  };
  
  return (
    <AdvisorsUIProvider advisorsUIEvents={advisorsUIEvents}>
      <AdvisorsCard />
    </AdvisorsUIProvider>
 );
}